(() => {
  const MOBILE_QUERY = '(max-width: 768px)';
  const FOOTER_SELECTOR = '.site-footer--fr';
  const CHAT_SELECTOR = 'shopify-chat, [data-fr-floating-chat]';
  const CHAT_STYLE_ID = 'fr-chat-icon-only';

  function makeChatIconOnly(chat) {
    if (!chat || chat.tagName !== 'SHOPIFY-CHAT' || !chat.shadowRoot) return;
    if (chat.shadowRoot.getElementById(CHAT_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = CHAT_STYLE_ID;
    style.textContent = `
      .activator {
        width: 52px !important;
        min-width: 52px !important;
        height: 52px !important;
        min-height: 52px !important;
        padding: 0 !important;
        border-radius: 50% !important;
        grid-template-columns: 1fr !important;
        place-items: center !important;
      }
      .activator__label {
        display: none !important;
      }
      .activator__icon {
        display: grid !important;
        width: 24px !important;
        height: 24px !important;
        margin: 0 !important;
        place-items: center !important;
      }
      .activator__icon svg {
        width: 24px !important;
        height: 24px !important;
      }
    `;
    chat.shadowRoot.appendChild(style);
  }

  function updateChatIcons() {
    document.querySelectorAll('shopify-chat').forEach(makeChatIconOnly);
  }

  function start() {
    updateChatIcons();

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-chat').then(updateChatIcons);
    }

    const iconObserver = new MutationObserver(updateChatIcons);
    iconObserver.observe(document.body, { childList: true, subtree: true });

    if (!document.body.classList.contains('template-index')) return;

    const footer = document.querySelector(FOOTER_SELECTOR);
    if (!footer) return;

    let chat = document.querySelector(CHAT_SELECTOR);
    let frame = 0;

    function applyOffset(target, offset, hidden) {
      target.style.setProperty(
        '--shopify-agent-activator-offset',
        `calc(${Math.round(offset)}px + env(safe-area-inset-bottom))`
      );

      if (target.hasAttribute('data-fr-floating-chat')) {
        target.style.bottom = `${Math.round(offset)}px`;
      }

      target.toggleAttribute('data-fr-footer-hidden', hidden);
    }

    function update() {
      frame = 0;
      if (!chat || !chat.isConnected) chat = document.querySelector(CHAT_SELECTOR);
      if (!chat) return;

      if (!window.matchMedia(MOBILE_QUERY).matches) {
        chat.style.removeProperty('--shopify-agent-activator-offset');
        chat.style.removeProperty('bottom');
        chat.removeAttribute('data-fr-footer-hidden');
        return;
      }

      const rect = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const intersects = rect.top < viewportHeight && rect.bottom > 0;

      if (!intersects) {
        applyOffset(chat, 16, false);
        return;
      }

      if (rect.bottom <= viewportHeight + 1) {
        applyOffset(chat, Math.max(16, viewportHeight - rect.bottom + 16), false);
        return;
      }

      if (rect.top > 72) {
        applyOffset(chat, viewportHeight - rect.top + 16, false);
        return;
      }

      applyOffset(chat, 16, true);
    }

    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    const observer = new MutationObserver(() => {
      updateChatIcons();
      if (!chat || !chat.isConnected) {
        chat = document.querySelector(CHAT_SELECTOR);
        schedule();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
